/** @format */

import React, { useEffect } from "react";
import FieldShell from "./labelInput/fieldShell";
import TextInput from "./labelInput/textInput";
import SelectInput from "./labelInput/selectInput";
import DateInput from "./labelInput/dateInput";
import TextAreaInput from "./labelInput/textAreaInput";

const LabelInput = ({
  id,
  label,
  type,
  placeholder,
  register,
  errors,
  watch,
  disabled,
  options,
  control,
  trigger,
  className,
  tooltipText,
  value = "",
  autoComplete,
  classNamelic,
  isLoading,
  isSearchable,
  maxLength,
  validateIcon = true,
  onChange = () => {},
  onInput = () => {},
  liveValidate = true,
  ...props
}) => {
  const showValidIcon = !errors && watch && validateIcon && !isLoading;

  useEffect(() => {
    if (watch && liveValidate) {
      const validate = async () => trigger(id);
      validate();
    }
  }, [watch]);

  let field;

  if (type === "textarea") {
    field = (
      <TextAreaInput
        id={id}
        placeholder={placeholder}
        register={register}
        disabled={disabled}
        maxLength={maxLength}
        errors={errors}
        showValidIcon={showValidIcon}
        tooltipText={tooltipText}
        onChange={onChange}
        onInput={onInput}
        {...props}
      />
    );
  } else if (type === "select") {
    field = (
      <SelectInput
        id={id}
        control={control}
        errors={errors}
        options={options}
        placeholder={placeholder}
        disabled={disabled}
        isLoading={isLoading}
        isSearchable={isSearchable}
        showValidIcon={showValidIcon}
        tooltipText={tooltipText}
        onChange={onChange}
        {...props}
      />
    );
  } else if (type === "date") {
    field = (
      <DateInput
        id={id}
        control={control}
        errors={errors}
        showValidIcon={showValidIcon}
      />
    );
  } else {
    field = (
      <TextInput
        id={id}
        type={type}
        placeholder={placeholder}
        register={register}
        disabled={disabled}
        autoComplete={autoComplete}
        maxLength={maxLength}
        classNamelic={classNamelic}
        errors={errors}
        showValidIcon={showValidIcon}
        tooltipText={tooltipText}
        onChange={onChange}
        onInput={onInput}
        {...props}
      />
    );
  }

  return (
    <FieldShell id={id} label={label} errors={errors} className={className}>
      {field}
    </FieldShell>
  );
};

export default LabelInput;
